import { render, staticRenderFns } from "./FirmNotesTable.vue?vue&type=template&id=bd6ec55c"
import script from "./FirmNotesTable.vue?vue&type=script&lang=js"
export * from "./FirmNotesTable.vue?vue&type=script&lang=js"
import style0 from "./FirmNotesTable.vue?vue&type=style&index=0&id=bd6ec55c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports